/* eslint-disable import/no-anonymous-default-export */
export default {
  CREATE_CONTACT: () => `/customer/contact/create`,
};
